var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"business"},[_c('List',{attrs:{"list":_vm.businessData,"titleHref":'/business'}}),_c('Pagination',{attrs:{"pageSize":_vm.pageSize,"count":_vm.count},on:{"pageNumber":_vm.pageBtn}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }